import { createRequestTypes } from '../utils';

export const COMPUTE_STATS = createRequestTypes('stats/COMPUTE');
